import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import DirectionPicker from '../../triangle-generator/DirectionPicker/DirectionPicker';
import SliderInput from '../../../components/SliderInput/SliderInput';
import Tabs from '../../../components/Tabs/Tabs';
import classes from './GradientSettings.styles.less';
const DIRECTIONS = {
    'top-left': 315,
    top: 0,
    'top-right': 45,
    left: 270,
    right: 90,
    'bottom-left': 225,
    bottom: 180,
    'bottom-right': 135,
};
export default function GradientSettings({ className, type, onTypeChange, angle, onAngleChange, }) {
    const [theme] = useTheme();
    const activeDirection = (type === 'linear' &&
        Object.keys(DIRECTIONS).find((direction) => DIRECTIONS[direction] === angle)) ||
        null;
    return (_jsxs("div", { className: cx(classes.settings, classes[theme], className), children: [_jsxs("div", { className: classes.field, children: [_jsx("div", { className: classes.label, children: "Gradient type" }), _jsx(Tabs, { data: [
                            { value: 'linear', label: 'Linear' },
                            { value: 'radial', label: 'Radial' },
                        ], onTabChange: onTypeChange, active: type })] }), type === 'linear' && (_jsxs(_Fragment, { children: [_jsxs("div", { className: classes.field, children: [_jsx("div", { className: classes.label, children: "Gradient direction" }), _jsx(DirectionPicker, { value: activeDirection, onChange: (direction) => onAngleChange(DIRECTIONS[direction]) })] }), _jsxs("div", { className: classes.field, children: [_jsx("div", { className: classes.label, children: "Gradient angle, deg" }), _jsx(SliderInput, { value: angle, onChange: onAngleChange, min: 0, max: 360, trackSize: 133 })] })] }))] }));
}
